import Textarea from '../../../Common/ui/textArea'
import { Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import AddSquareIcon from '../../../Common/Icon/AddSquareIcon'
import '../../../Styles/FormQuestionTable.css'
import { cn } from 'src/lib/utils'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import ContentCircle from 'src/Common/ui/contentCircle'

function FormsQuestionTable({ activeTab, inputValidation, control, data, errors, onInputChangeTextArea, onInputChange, handleAddControls, handleDeleteControls, i, formFileRef }) {
    const location = useLocation()
    const viewCondition = () => {
        const path = location.pathname
        if (path.includes('Add') || path.includes('Edit')) {
            return false
        } else {
            return true
        }
    }
    const [paginatedData, setPaginatedData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const { t } = useTranslation()
    const rowsPerPage = 5
    const totalPages = Math.ceil(data.length / rowsPerPage)
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }

    useEffect(() => {
        if (data.length > 0) {
            if (viewCondition()) {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
            }
        }
    }, [data, currentPage])
    const [disable, setDisable] = useState(false)

    useEffect(() => {
        if (!viewCondition() && paginatedData.length > 0) {
            const find = paginatedData.every((ele) => {
                return ele.documentName && ele.hyperLink &&
                    ele.submitTo &&
                    ele.penaltiesandFine &&
                    ele.damageToReputation
            })
            if (find) {
                setDisable(false)
            } else {
                setDisable(true)
            }
        }
    }, [paginatedData])
    const [entries, setEntries] = useState({
        entry: 0,
        from: 0,
        to: 0
    })
    useEffect(() => {
        setEntries({
            entry: data?.length,
            from: (currentPage - 1) * rowsPerPage + 1,
            to: (currentPage - 1) * rowsPerPage + paginatedData?.length - 1 + 1
        })
    }, [paginatedData])
    return (
        <>
            <div style={{ display: activeTab === 2 ? 'block' : 'none', height: '100%' }}>
                <div className='h-[86%]'>
                    <TableContainer className={cn('forms-comp-table global-table')}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ border: 'none' }} colSpan={4}></TableCell>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '17px' }} align='center' colSpan={2}>Cost of Non Compliance</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '17px', position: 'sticky', top: 0, left: '0px' }} align='center' className='!px-0'>
                                        #</TableCell>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '17px', position: 'sticky', top: 0, left: '49px' }} className='!px-0'>
                                        <p className={cn('comp-table-th px-3', 'flex flex-col flex-grow justify-center px-3 whitespace-nowrap min-w-[174px]')}>{t('Form Name')}</p></TableCell>
                                    {/* <TableCell sx={{ fontWeight: 600, fontSize: '17px', position: 'sticky', top: 0, width: '100px', left: '274px' }} className='!px-0'>
                                        <p className={cn('comp-table-th px-3', 'flex flex-col flex-grow justify-center px-3 whitespace-nowrap min-w-[150px]')}>{t('Documents')}</p></TableCell>
                                     */}
                                    <TableCell sx={{ fontWeight: 600, fontSize: '17px', position: 'sticky', top: 0, left: '301px', padding: 0 }} className='!px-0'>
                                        <p style={{ borderRight: '1.5px solid hsl(var(--table-bisector))' }} className={cn('h-[60px] flex items-center')}>
                                            <p className={cn('comp-table-th px-3', 'flex flex-col flex-grow justify-center px-3 whitespace-nowrap min-w-[150px]')}>{'Hyperlink'}</p></p></TableCell>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '17px' }} className='!px-0'>
                                        <p className={cn(' px-3', 'flex flex-col flex-grow justify-center px-3 whitespace-nowrap')}>{t('Submit to')}</p></TableCell>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '17px' }} className='!px-0'>
                                        <p className={cn('comp-table-th px-3', 'flex flex-col flex-grow justify-center px-3 whitespace-nowrap')}>{t('Penalties and fines')}</p></TableCell>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '17px' }} className='!px-0'>
                                        <p className={cn('comp-table-th px-3', 'flex flex-col flex-grow justify-center px-3 whitespace-nowrap')}>{t('Damage to Reputation')}</p></TableCell>
                                    {data.length > 1 && !viewCondition() && <TableCell sx={{ position: 'sticky', right: '0', zIndex: 2, padding: 0 }}></TableCell>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (viewCondition() ? paginatedData : data)?.map((item, j) => {
                                        item.sNo = j + 1
                                        return (
                                            <>
                                                <TableRow key={j}>
                                                    <TableCell sx={{ position: 'sticky', top: 0, left: '0px', zIndex: 2 }}>
                                                        <div className='w-full flex justify-center'> <div className='w-full flex justify-center'>
                                                            <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary text-sm'} content={item.sNo} />

                                                        </div>

                                                        </div>
                                                    </TableCell>
                                                    <TableCell sx={{ position: 'sticky', top: 0, left: '49px', zIndex: 2 }}>
                                                        <p className={cn('forms-comp-table-td flex justify-center')}>
                                                            {viewCondition()
                                                                ? <div>{item.documentName}</div>
                                                                : <Textarea
                                                                    errors={errors}
                                                                    control={control}
                                                                    required
                                                                    rules={{
                                                                        validate: (value) => {
                                                                            return inputValidation(value, value?.length < 55, 'This field is required', 'Characters should be less than 55')
                                                                        }
                                                                    }}
                                                                    name={`forms-documentName-${j}`}
                                                                    placeholder={t('Enter the Form Name')}
                                                                    type="text"
                                                                    onValueChange={(e) => onInputChangeTextArea(e, `forms-documentName-${j}`)}
                                                                    value={item.documentName}
                                                                    className='!border-none !ring-0 textarea !shadow-none !h-14 !p-0'
                                                                    maxLength={250}
                                                                />}
                                                        </p>
                                                    </TableCell>
                                                    {/* <TableCell align='center' sx={{ position: 'sticky', top: 0, left: '274px', zIndex: 2 }}>
                                                        <p className={cn('forms-comp-table-td flex justify-center')}>
                                                            <MenuItem disabled={true}>
                                                                {viewCondition()
                                                                    ? <Badge badgeContent={item?.documents?.length} color="primary">
                                                                        <img onClick={() => { formFileRef.current[j]?.click() }} src='/Common/icon/SheetIcon.svg' />
                                                                    </Badge>
                                                                    : <><div className='flex justify-center items-center min-h-[60px] w-full h-full'> */}
                                                    {/* {item.documents?.length === 0 && */}
                                                    {/* <Tooltip title="Upload Document" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                                            <img className='w-7' onClick={() => { formFileRef.current[j]?.click() }} src='/Common/icon/uploadIconGreen.svg' />
                                                                        </Tooltip> */}
                                                    {/* } */}
                                                    {/* {item.documents?.length > 0 && <div>
                                                                            <Badge badgeContent={item.documents.length} color="primary">
                                                                                <img onClick={() => { formFileRef.current[j]?.click() }} src='/Common/icon/SheetIcon.svg' />
                                                                            </Badge>
                                                                        </div>} */}
                                                    {/* </div>
                                                                    <div>
                                                                        <Input
                                                                            errors={errors}
                                                                            control={control}
                                                                            // required
                                                                            // rules={{ required: 'This field is Required' }}
                                                                            name={`Forms-documents-${j}`}
                                                                            placeholder={t('Enter a Question')}
                                                                            type="file"
                                                                            multiple={true}
                                                                            // ref={el => (formFileRef.current[j] = el)}
                                                                            onValueChange={(e) => onInputChange(e, `upload-documents-${j}`)}
                                                                            // value={item.documents}
                                                                            className='!border-none !ring-0 !shadow-none hidden'
                                                                        />
                                                                    </div></>}
                                                            </MenuItem>
                                                        </p>
                                                    </TableCell> */}
                                                    <TableCell sx={{ position: 'sticky', top: 0, left: '301px ', zIndex: 2, padding: 0 }}>
                                                        <p className={cn('h-[60px] flex items-center')}><p className={cn('forms-comp-table-td flex justify-center')}>
                                                            {viewCondition()
                                                                ? <div className="px-3">
                                                                    {item.hyperLink
                                                                        ? <a href={item.hyperLink} className='text-primary underline' target="_blank" rel="noreferrer" >
                                                                            {item.hyperLink}
                                                                        </a>
                                                                        : <div className='text-muted text-center'>NA</div>}
                                                                </div>
                                                                : <Textarea
                                                                    errors={errors}
                                                                    control={control}
                                                                    // required
                                                                    rules={{
                                                                        validate: (value) => {
                                                                            const urlRegex = /\b((?:https?:\/\/|www\d{0,3}[.])?[a-z0-9.-]+[.](?:[a-z]{2,13})(?:[:]\d+)?(?:[/?#]\S*)?)\b/i
                                                                            function containsURL(text) {
                                                                                return urlRegex.test(text)
                                                                            }
                                                                            if (value?.length > 0 && !containsURL(value)) {
                                                                                return 'Please enter a valid URL'
                                                                            }
                                                                            return true
                                                                        }
                                                                    }}
                                                                    name={`forms-hyperLink-${j}`}
                                                                    placeholder="Enter an URL"
                                                                    type="text"
                                                                    onValueChange={(e) => onInputChangeTextArea(e, `forms-hyperLink-${j}`)}
                                                                    value={item.hyperLink}
                                                                    className='!border-none !ring-0 textarea !shadow-none !h-14 !p-0'
                                                                />}
                                                        </p>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell sx={{ position: 'sticky', top: 0 }} align='center'>
                                                        <p className={cn('h-[60px] flex items-center justify-center')}><p className={cn('forms-comp-table-td w-full flex justify-center')}>
                                                            {viewCondition()
                                                                ? <div className='px-3 text-center'>{item.submitTo || 'NA'}</div>
                                                                : <Textarea
                                                                    errors={errors}
                                                                    control={control}
                                                                    // required
                                                                    rules={{
                                                                        validate: (value) => {
                                                                            return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250', false)
                                                                        }
                                                                    }}
                                                                    name={`forms-submitTo-${j}`}
                                                                    placeholder={t('Enter Submit To')}
                                                                    type="text"
                                                                    onValueChange={(e) => onInputChangeTextArea(e, `forms-submitTo-${j}`)}
                                                                    value={item.submitTo}
                                                                    className='!border-none !ring-0 textarea !shadow-none !h-14 !p-0'
                                                                    maxLength={250}
                                                                />}
                                                        </p>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{}}>
                                                        <p className={cn('forms-comp-table-td flex justify-center min-w-[170px]')}>
                                                            {viewCondition()
                                                                ? <div className='align-center px-3'>{item.penaltiesandFine || 'NA'}</div>
                                                                : <Textarea
                                                                    errors={errors}
                                                                    control={control}
                                                                    // required
                                                                    rules={{
                                                                        validate: (value) => {
                                                                            return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250', false)
                                                                        }
                                                                    }}
                                                                    name={`forms-penaltiesandFine-${j}`}
                                                                    placeholder={t('Enter Penalty And Fine')}
                                                                    type="text"
                                                                    onValueChange={(e) => onInputChangeTextArea(e, `forms-penaltiesandFine-${j}`)}
                                                                    value={item.penaltiesandFine}
                                                                    defaultValue={item.penaltiesandFine}
                                                                    className='!border-none !ring-0 textarea !shadow-none !h-14 !p-0'
                                                                    maxLength={250}
                                                                />}
                                                        </p></TableCell>
                                                    <TableCell align='center' sx={{}}>
                                                        <p className={cn('forms-comp-table-td flex justify-center min-w-[170px]')}>
                                                            {viewCondition()
                                                                ? <div className='align-center px-3'>{item.damageToReputation || 'NA'}</div>
                                                                : <Textarea
                                                                    errors={errors}
                                                                    control={control}
                                                                    // required
                                                                    rules={{
                                                                        validate: (value) => {
                                                                            return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250', false)
                                                                        }
                                                                    }}
                                                                    name={`forms-damageToReputation-${j}`}
                                                                    placeholder={t('Enter Damage To Reputation')}
                                                                    type="text"
                                                                    onValueChange={(e) => onInputChangeTextArea(e, `forms-damageToReputation-${j}`)}
                                                                    value={item.damageToReputation}
                                                                    defaultValue={item.damageToReputation}
                                                                    className='!border-none !ring-0 textarea !shadow-none !h-14 !p-0'
                                                                    maxLength={250}
                                                                />}
                                                        </p>
                                                    </TableCell>
                                                    {data.length > 1 && !viewCondition() && <TableCell sx={{ position: 'sticky', right: '0', zIndex: 2, padding: 0 }}><div className='w-10 flex justify-center' onClick={() => handleDeleteControls('forms', j)}><img src='/Common/Icon/DeleteIconGov.svg' className='w-[25px] h-[25px]' /></div></TableCell>}

                                                </TableRow>
                                            </>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {viewCondition() && data.length > 0 && <div className="border-t-2 border-t-primary-foreground flex items-center justify-between mt-2 p-4 h-[10%]">
                        <Typography className="text-muted !text-h4">
                            Showing data {entries.from} to {entries.to} of {entries.entry} entries
                        </Typography>
                        <Pagination
                            sx={{ marginLeft: 'auto' }}
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded" />
                    </div>}
                </div>

                {!viewCondition() && <div className='w-full flex justify-end mt-5 pr-1 cursor-pointer'>
                    <div className={cn(disable ? 'bg-popover pr-1 rounded-sm !text-card pointer-events-none' : '', 'flex gap-2 items-center text-primary')} onClick={() => { handleAddControls('forms') }}><AddSquareIcon fill={disable ? 'hsl(var(--card))' : 'hsl(var(--primary))'} /> <span>New</span></div>
                </div>}
            </div>
        </>
    )
}

FormsQuestionTable.propTypes = {
    controls: PropTypes.any,
    control: PropTypes.any,
    errors: PropTypes.any,
    data: PropTypes.any,
    formFileRef: PropTypes.any,
    onInputChangeTextArea: PropTypes.func,
    onInputChange: PropTypes.func,
    handleAddControls: PropTypes.func,
    handleDeleteControls: PropTypes.func,
    i: PropTypes.number,
    activeTab: PropTypes.any,
    inputValidation: PropTypes.func
}

export default FormsQuestionTable
